import script from "./ToggleComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ToggleComponent.vue?vue&type=script&setup=true&lang=js"

import "./ToggleComponent.vue?vue&type=style&index=0&id=98e74952&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98e74952"]])

export default __exports__